var map = {
	"./1.png": "e668",
	"./2.png": "cdbd",
	"./3.png": "6b5b",
	"./4.png": "1590",
	"./5.png": "26f2",
	"./6.png": "7e56",
	"./7.png": "de8d",
	"./8.png": "37d3",
	"./9.png": "5437"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "978c";